import React, { Children } from 'react';
export const PrivacyPolicy = () => {
  return <div className="w-full" data-id="element-355">
      {/* Header */}
      <div className="bg-primary py-16 w-full" data-id="element-356">
        <div className="container mx-auto px-4" data-id="element-357">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-358">
            Privacy and Cookie Policy
          </h1>
          <p className="text-xl text-white/90" data-id="element-359">
            How we protect and manage your personal data
          </p>
        </div>
      </div>
      {/* Content */}
      <section className="py-16 bg-light" data-id="element-360">
        <div className="container mx-auto px-4" data-id="element-361">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-362">
            <h2 className="text-2xl font-bold text-primary mb-6" data-id="element-363">
              Privacy and Cookie Policy - Prismedge
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-364">
              At Prismedge, protecting your privacy is a priority. This policy
              explains what information we collect, how we use it, and how we
              keep it secure, ensuring you have confidence in our handling of
              your personal data.
            </p>
            <div className="space-y-8" data-id="element-365">
              <div data-id="element-366">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-367">
                  1. Who We Are
                </h3>
                <p className="text-gray-600" data-id="element-368">
                  Prismedge is a UK-based appliance repair and service company
                  specializing in essential household systems.
                </p>
              </div>
              <div data-id="element-369">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-370">
                  2. What Information We Collect
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-371">
                  We may collect the following information from you to provide
                  our services and manage your account effectively:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-372">
                  <li data-id="element-373">
                    Your name and contact details: Including your address, email
                    (rawalraj2057@gmail.com), and phone number (0800 055 4969).
                  </li>
                  <li data-id="element-374">
                    Payment information: Processed securely through our trusted
                    payment providers.
                  </li>
                  <li data-id="element-375">
                    Records of your service plans and repair history: To ensure
                    continuity of service and support.
                  </li>
                </ul>
              </div>
              <div data-id="element-376">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-377">
                  3. How We Use Your Information
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-378">
                  We use your data primarily to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-379">
                  <li data-id="element-380">
                    Manage and administer your service plans: Including
                    activation, renewals, and plan adjustments.
                  </li>
                  <li data-id="element-381">
                    Arrange repairs and provide customer support: Dispatching
                    engineers and addressing your queries.
                  </li>
                  <li data-id="element-382">
                    Send important updates and information: Related to your
                    service, appointments, and policy changes.
                  </li>
                  <li data-id="element-383">
                    Comply with legal and regulatory obligations: Ensuring we
                    operate within the law.
                  </li>
                </ul>
              </div>
              <div data-id="element-384">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-385">
                  4. Third-Party Providers
                </h3>
                <p className="text-gray-600" data-id="element-386">
                  We work with trusted third parties, such as payment processors
                  and website hosting providers, to deliver our services
                  efficiently and securely. We want to assure you that we do not
                  sell your personal information to any third parties.
                </p>
              </div>
              <div data-id="element-387">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-388">
                  5. Cookies
                </h3>
                <p className="text-gray-600" data-id="element-389">
                  Our website uses cookies to enhance your browse experience and
                  improve site performance. Cookies are small data files stored
                  on your device that help us understand how you interact with
                  our site. You can manage or disable cookies through your
                  browser settings at any time, but please note this may affect
                  certain website functionalities.
                </p>
              </div>
              <div data-id="element-390">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-391">
                  6. Your Rights
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-392">
                  Under applicable data protection laws, you have specific
                  rights regarding your personal data. You have the right to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-393">
                  <li data-id="element-394">
                    Request access to the personal data we hold about you.
                  </li>
                  <li data-id="element-395">Ask for corrections or deletion of your data.</li>
                  <li data-id="element-396">
                    Withdraw your consent to marketing communications at any
                    time.
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-397">
                  To exercise these rights, please contact us at:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-398">
                  <li data-id="element-399">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-400">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                  <li data-id="element-401">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-402">
                      0800 055 4969
                    </a>
                  </li>
                </ul>
              </div>
              <div data-id="element-403">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-404">
                  7. Sharing Your Data
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-405">
                  We may share your information with:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-406">
                  <li data-id="element-407">
                    Service providers essential to our operations: Such as
                    payment processors, IT support, and website hosting
                    services, who act on our behalf.
                  </li>
                  <li data-id="element-408">
                    Law enforcement or regulatory authorities: When required by
                    law or in response to a valid legal request.
                  </li>
                  <li data-id="element-409">
                    Marketing partners: But only with your explicit consent,
                    which you can withdraw at any time.
                  </li>
                </ul>
              </div>
              <div data-id="element-410">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-411">
                  8. Data Retention
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-412">
                  We retain your personal data only as long as necessary to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-413">
                  <li data-id="element-414">Provide and manage our services to you effectively.</li>
                  <li data-id="element-415">Comply with legal and regulatory requirements.</li>
                  <li data-id="element-416">Resolve disputes or complaints.</li>
                </ul>
              </div>
              <div data-id="element-417">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-418">
                  9. Children's Privacy
                </h3>
                <p className="text-gray-600" data-id="element-419">
                  Our services are not intended for individuals under 16 years
                  old. We do not knowingly collect personal data from minors. If
                  we become aware that such data has been collected, we will
                  take steps to delete it.
                </p>
              </div>
              <div data-id="element-420">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-421">
                  10. Data Security
                </h3>
                <p className="text-gray-600" data-id="element-422">
                  We implement strong security measures, including technical and
                  organizational safeguards, to protect your information from
                  unauthorized access, accidental loss, destruction, or
                  alteration. While we strive for robust security, please
                  understand that no system can guarantee 100% security during
                  data transmission over the internet.
                </p>
              </div>
              <div data-id="element-423">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-424">
                  11. International Data Transfers
                </h3>
                <p className="text-gray-600" data-id="element-425">
                  Your data may be stored or processed outside the UK or
                  European Economic Area by our service providers. Where this
                  happens, we ensure appropriate safeguards are in place to
                  protect your data in accordance with relevant data protection
                  laws.
                </p>
              </div>
              <div data-id="element-426">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-427">
                  12. Updates to This Policy
                </h3>
                <p className="text-gray-600" data-id="element-428">
                  We may update this privacy policy occasionally to reflect
                  changes in our practices, technology, or legal requirements.
                  Any changes will be published here with the updated date. We
                  encourage you to review this policy regularly to stay
                  informed.
                </p>
              </div>
              <div data-id="element-429">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-430">
                  13. Contact Us
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-431">
                  If you have any questions or concerns about your data or this
                  policy, please do not hesitate to contact us:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-432">
                  <li data-id="element-433">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-434">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                  <li data-id="element-435">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-436">
                      0800 055 4969
                    </a>
                  </li>
                  <li data-id="element-437">Address: 78 Austhorpe Rd, Leeds LS15 8EF</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};